import { Directive, Input, output } from '@angular/core';
import { MachineTaskUpsertModel } from '../upsert-machine-task-wizard.component';
import { MachineDescriptionStepComponent } from './description-step/description-step.component';
import { MachineStepComponent } from './machine-step/machine-step.component';
import { MachineDocumentsStepComponent } from './documents-step/documents-step.component';
import { MachineSchedulingStepComponent } from './scheduling-step/scheduling-step.component';
import { UntypedFormGroup } from '@angular/forms';

export type StepComponent =
  | MachineDescriptionStepComponent
  | MachineStepComponent
  | MachineDocumentsStepComponent
  | MachineSchedulingStepComponent;

@Directive()
export class MachineStepBaseComponent {
  @Input() public machineTaskModel: MachineTaskUpsertModel;
  public readonly machineTaskModelChange = output<MachineTaskUpsertModel>();

  public stepForm = new UntypedFormGroup({});

  public get valid(): boolean {
    return this.stepForm?.valid;
  }
}
